import store from 'owa-mail-store/lib/store/Store';
import { action } from 'satcheljs/lib/legacy';
import isTabViewEnabled from 'owa-tab-store/lib/utils/isTabViewEnabled';
import { lazyActivateTab, primaryTab } from 'owa-tab-store';
/**
 * Sets showReadingPane value in store to passed in value
 * @param showReadingPane Whether to show reading pane
 */
export default action('setShowReadingPane')(function setShowReadingPane(showReadingPane) {
    store.mailModule.showReadingPane = showReadingPane;
    if (isTabViewEnabled()) {
        // Whenever show/hide reading pane, it means we are operating on the primary tab
        lazyActivateTab.importAndExecute(primaryTab);
    }
});
//# sourceMappingURL=setShowReadingPane.js.map